if (!customElements.get('hendly-size-guide')) {
  customElements.define('hendly-size-guide', class HendlySizeGuide extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || this.initialized) return;

      this.initialized = true;
      this.initialGender = this.dataset.initialGender;
      this.initialCategory = this.dataset.initialCategory;
      this.state = { gender: this.initialGender, category: this.initialCategory, unit: 'inches' };
      this.triggers = Array.from(document.querySelectorAll(`[data-size-guide-open="${this.dialog.id}"]`));

      this.triggers.forEach((trigger) => trigger.addEventListener('click', () => this.open()));
      this.querySelector('[data-size-guide-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.querySelectorAll('[data-size-guide-gender]').forEach((button) => {
        button.addEventListener('click', () => {
          this.state.gender = button.dataset.sizeGuideGender;
          this.render();
        });
      });
      this.querySelectorAll('[data-size-guide-category]').forEach((button) => {
        button.addEventListener('click', () => {
          this.state.category = button.dataset.sizeGuideCategory;
          this.render();
        });
      });
      this.querySelectorAll('[data-size-guide-unit]').forEach((button) => {
        button.addEventListener('click', () => {
          this.state.unit = button.dataset.sizeGuideUnit;
          this.render();
        });
      });
      this.render();
    }

    open() {
      this.state = { gender: this.initialGender, category: this.initialCategory, unit: 'inches' };
      this.render();
      this.dialog.showModal();
    }

    convertToCentimetres(value) {
      return value.split('-').map((number) => String(Math.round(Number(number) * 2.54))).join('-');
    }

    render() {
      this.querySelectorAll('[data-size-guide-gender]').forEach((button) => {
        button.setAttribute('aria-selected', String(button.dataset.sizeGuideGender === this.state.gender));
      });
      this.querySelectorAll('[data-size-guide-category]').forEach((button) => {
        button.setAttribute('aria-selected', String(button.dataset.sizeGuideCategory === this.state.category));
      });
      this.querySelectorAll('[data-size-guide-unit]').forEach((button) => {
        button.setAttribute('aria-selected', String(button.dataset.sizeGuideUnit === this.state.unit));
      });
      this.querySelectorAll('[data-size-guide-table]').forEach((table) => {
        table.hidden = table.dataset.gender !== this.state.gender || table.dataset.category !== this.state.category;
      });
      this.querySelectorAll('[data-inches]').forEach((cell) => {
        if (this.state.unit === 'inches') {
          cell.textContent = cell.dataset.inches;
        } else {
          cell.textContent = cell.dataset.cm || this.convertToCentimetres(cell.dataset.inches);
        }
      });
      this.querySelectorAll('[data-measurement-heading]').forEach((heading) => {
        const unit = this.state.unit === 'inches' ? 'in' : 'cm';
        heading.textContent = `${heading.dataset.label} (${unit})`;
      });

      const genderButton = this.querySelector(`[data-size-guide-gender="${this.state.gender}"]`);
      const groupLabel = this.state.category === 'shoes' ? this.dataset.footwearLabel : this.dataset.apparelLabel;
      this.querySelector('[data-size-guide-kicker]').textContent = `${genderButton.textContent.trim()} ${groupLabel}`;
    }
  });
}
